import { render, staticRenderFns } from "./exhibitorsOne.vue?vue&type=template&id=2dc31ff0&"
import script from "./exhibitorsOne.vue?vue&type=script&lang=js&"
export * from "./exhibitorsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports